import React from 'react'
import { resolveQuery } from '../helpers'
import { Entry, Resolution } from '../../EntryListItem/Entry'
import { EntryData } from './EntryData'
import '../TrafficEntry.module.sass'
import { EntryPoint } from './ResolutionData'

import { EntrySource } from '../../../types/trafficEntry'

interface NodeNameProps {
  entry: Entry,
  point?: EntryPoint
  bothPoints?: boolean
}

export const NodeName: React.FC<NodeNameProps> = ({ entry, point = EntrySource, bothPoints = false }) => {
  if (bothPoints) {
    if (!entry?.src?.pod?.spec?.nodeName && !entry?.dst?.pod?.spec?.nodeName) {
      return null
    }

    if (entry?.src?.pod?.spec?.nodeName === entry?.dst?.pod?.spec?.nodeName) {
      return (
        <EntryData
          name={entry?.src?.pod?.spec?.nodeName}
          query={
            `${resolveQuery(`src.pod.spec.nodeName`, '==', entry?.src?.pod?.spec?.nodeName)}
            and ${resolveQuery(`dst.pod.spec.nodeName`, '==', entry?.dst?.pod?.spec?.nodeName)}`
          }
          zIndex={3}
          tooltipStyle={{
            transform: 'translate(15px, -20px)',
          }}
        />
      )
    }
  } else {
    const resolution: Resolution = entry[point]

    const entryData = {
      nodeName: resolution.pod?.spec?.nodeName ? resolution.pod?.spec?.nodeName : '-',
    }

    if (entryData.nodeName === '-') {
      return null
    }

    return <EntryData
      name={entryData.nodeName}
      query={resolveQuery(`${point}.pod.spec.nodeName`, '==', entryData.nodeName)}
      zIndex={3}
    />
  }
}
